import React from 'react';
import PropTypes from 'prop-types';
import map from 'lodash/map';

import SidebarNumberedItem from './components/SidebarNumberedItem';
import SidebarHeader from './components/SidebarHeader';
import SidebarSummary from './components/SidebarSummary';

const NumberedSidebar = ({ activeIndex, title, pageTitles, handleViewChange, summary }) => {
  return (
    <React.Fragment>
      <SidebarHeader>{title}</SidebarHeader>
      { map(pageTitles, (pageTitle, i) => {
        return (
          <SidebarNumberedItem
            key={pageTitle}
            index={i}
            activeIndex={activeIndex}
            onClick={() => handleViewChange(i)}
          >
            {pageTitle}
          </SidebarNumberedItem>
        );
      })}
      { summary &&
        <SidebarSummary
          header={summary[0]}
          items={summary.slice(1)}
        />
      }
    </React.Fragment>
  );
};

NumberedSidebar.propTypes = {
  activeIndex: PropTypes.number,
  title: PropTypes.string,
  pageTitles: PropTypes.array,
  handleViewChange: PropTypes.func,
  summary: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.any
  ])
};

export default NumberedSidebar;
